import { useCallback } from "react"

import { useDispatch, useSelector } from "react-redux"

import { resolveCompare } from "../../../Components/Filters/DashboardFiltersBlock/resolveCompare"
import HealthActions from "../reducer"

export const useMonitoringPeriodChange = () => {
  const dispatch = useDispatch()
  const { filters, monitoringCompare } = useSelector((state) => state.health)

  return useCallback(
    (newFilters) => {
      const { period: nextPeriod, ...rest } = newFilters || {}

      if (!nextPeriod) {
        dispatch(HealthActions.healthSetProp("filters", { ...filters, period: "27 days" }))
        return
      }

      const compare = monitoringCompare?.compare ?? null
      const lastCompare = monitoringCompare?.lastCompare ?? null
      const wasAllTime = filters?.period === "all"

      const nextCompare =
        nextPeriod === "all"
          ? { compare: null, lastCompare: compare || lastCompare || null }
          : {
              compare: resolveCompare(wasAllTime ? lastCompare : compare, nextPeriod),
              lastCompare: wasAllTime ? null : lastCompare
            }

      dispatch(HealthActions.healthSetProp("monitoringCompare", nextCompare))
      dispatch(
        HealthActions.healthSetProp("filters", {
          ...filters,
          ...rest,
          period: Array.isArray(nextPeriod) ? { type: "custom", period: nextPeriod } : nextPeriod
        })
      )
    },
    [dispatch, filters, monitoringCompare]
  )
}
